import React from "react";
import logo from '../../assets/img/logo.png'
const Logo = () => {
    const logoStyle = {
        width: '120px'
    }
    return (<img style={logoStyle} src={logo} alt="Zdjęcie przedstawia logo strony watchFlow"/>)
}
export default Logo
